const TestimonialsSlider = {

    init(){
        this.el = $('[module="testimonials"][section="slider"] .slider');
        if(!this.el.length) return;
        this.bind();
    },

    bind(){
        this.el.addClass('owl-carousel');
        this.el.owlCarousel({
            "loop": false,
            "autoWidth": false,
            "nav": true,
            "dots": true,
            "progress": true,
            "counter": false,
            "margin": 48,
            "stagePadding": 0,
            "items": 1,
            "navText": ["", ""],

            "responsive": {
                "1280": {
                    "items": 4
                },
                "1000": {
                    "items": 3
                },
                "640": {
                    "items": 2
                },
                "0": {
                    "stagePadding": 15
                }
            }
        });
    },
}

export default TestimonialsSlider;